/**
 * Intake workflow tab configuration.
 *
 * Tab order: extraction -> eligibility -> prior_auth -> ready_to_call -> scheduling -> push_to_emr
 *
 * Note: Tabs can be completed in any order. There is no enforced prerequisite
 * ordering - users may skip ahead or complete tabs out of sequence as needed.
 */

import { FeatureFlag, type FeatureFlagType } from './featureFlags';

export type IntakeTabKey =
  | 'extraction'
  | 'eligibility'
  | 'prior_auth'
  | 'ready_to_call'
  | 'scheduling'
  | 'push_to_emr';

export interface EnabledTabs {
  extraction?: boolean;
  eligibility?: boolean;
  prior_auth?: boolean;
  ready_to_call?: boolean;
  scheduling?: boolean;
  push_to_emr?: boolean;
}

/**
 * Default enabled tabs configuration when feature flags are not available.
 * Used as default props in components that accept enabledTabs.
 */
export const DEFAULT_ENABLED_TABS: Required<EnabledTabs> = {
  extraction: true,
  eligibility: true,
  prior_auth: true,
  ready_to_call: true,
  scheduling: true,
  push_to_emr: true,
};

/**
 * Feature flag names for each intake tab.
 */
export const TAB_FEATURE_FLAGS: Record<IntakeTabKey, FeatureFlagType | null> = {
  extraction: null, // Always enabled
  eligibility: FeatureFlag.INTAKE_ELIGIBILITY_CHECK_SUPPORT,
  prior_auth: FeatureFlag.INTAKE_PRIOR_AUTH_SUPPORT,
  ready_to_call: FeatureFlag.INTAKE_READY_TO_CALL_SUPPORT,
  scheduling: FeatureFlag.INTAKE_SCHEDULING_SUPPORT,
  push_to_emr: FeatureFlag.INTAKE_SCHEDULING_SUPPORT, // Same flag as scheduling
};
